import React from 'react';

function Nomatch() {
  return (
    <div>
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. At, consequatur maiores impedit modi maxime qui quaerat dignissimos voluptates, ipsum ullam ipsam quisquam quas laboriosam nostrum minima amet tenetur? Obcaecati, architecto?
    </div>
  );
}

export default Nomatch;
